(() => {
  const name = 'link-list';

  App.common = App.common || {};

  App.common[name] = (() => {
    const animationSpeed = '150';

    const bindEventListeners = () => {
      $('[data-link-list-submenu]')
        .on('click', (event) => {
          // links inside submenu should still be clickable
          if ($(event.target).is('.link-list__submenu-item, .link-list__submenu-item-list a')) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          const $target = $(event.currentTarget);
          if ($target.has('.link-list__submenu')) {
            const fullHeight = $target.find('.link-list__submenu').get(0).scrollHeight;
            if ($target.is('[data-link-list-submenu="closed"]')) {
              $target.find('.link-list__submenu').animate({ height: fullHeight }, animationSpeed);
              $target.attr('data-link-list-submenu', 'open');
            } else if ($target.is('[data-link-list-submenu="open"]')) {
              $target.find('.link-list__submenu').animate({ height: '0' }, animationSpeed);
              $target.attr('data-link-list-submenu', 'closed');
            }
          }
        });
    };

    const init = () => {
      bindEventListeners();
    };

    return {
      init,
    };
  })();
})();
